import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";
import { Link } from "react-router-dom";
import { validateEmailFormat } from "../../Global/tools.js";
import SimpleButton from "../../Buttons/SimpleButton.js";
import LinkButton from "../../Buttons/LinkButton.js";

// Componets
import Input from "../../Forms/Input.js";
import Textarea from "../../Forms/Textarea.js";

import { ReactComponent as CaptchaImage } from "./../../Global/images/reCaptchaImage.svg";
import { ReactComponent as CloseIcon } from "./../../Global/icons/cross.svg";
import { ReactComponent as WarningIcon } from "./../../Global/icons/warning.svg";
import { ReactComponent as InfoIcon } from "./../../Global/icons/infoMark.svg";
import { ReactComponent as CheckIcon } from "./../../Global/icons/check.svg";

const StyledContactBlock = styled(NanoFlex)`
  height: auto;
  padding: 124px 150px;
  gap: 96px;

  .checkbox {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    height: 16px;
    width: 16px;
    cursor: pointer;
    font-size: 16px;
    user-select: none;
    cursor: pointer;
    margin-right: 12px;

    .checkmark {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      height: 16px;
      width: 16px;
      padding: 0px;
      background-color: ${(props) => props.theme.color.primaryColors.white};
      border-radius: 3px;
      transition: background-color 0.4s ease-in-out;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid ${(props) => props.theme.color.primaryColors.borderGrey};

      &::after {
        content: "";
        height: 100%;
        width: 100%;
        display: none;
        background-color: #556aeb;
      }

      svg {
        opacity: 0;
        height: 14px;
        width: auto;

        path {
          stroke: ${(props) => props.theme.color.primaryColors.white};
          stroke-width: 3px;
        }
      }
    }

    input[type="checkbox"] {
      position: absolute;
      opacity: 0;
      height: 100%;
      width: 100%;
      z-index: 2;
      margin: 0;
      cursor: pointer;

      &:checked ~ .checkmark {
        background-color: ${(props) => props.theme.color.primaryColors.labelPurple};
        border: 1px solid ${(props) => props.theme.color.primaryColors.labelPurple};

        svg {
          opacity: 1;
        }
      }
    }
  }

  .contactsLeftBlock {
    gap: 24px;
    .blockTitle {
      height: auto;
    }
    .contactTextBlock {
      height: auto;

      p {
        text-transform: none !important;
        color: ${(props) => props.theme.color.primaryColors.secFontColor};
      }
    }

    .contactFormWrapper {
      gap: 24px;

      .formDouble {
        gap: 16px;

        p {
          line-height: normal;
        }

        .radioForm {
          gap: 10px;

          .bold {
            font-weight: bold;
            text-transform: uppercase;
          }
        }
      }

      a {
        font-family: ${(props) => props.theme.font};
        font-size: 18px;
        user-select: none;
        cursor: pointer;
        text-decoration: none;
        color: ${(props) => props.theme.color.primaryColors.darkPurple};
        user-select: none;
        text-transform: none;

        /* MEDIA QUERIES */

        @media only screen and (max-width: 1450px) {
          font-size: 14px;
        }

        @media only screen and (max-width: 1024px) {
          font-size: 12px;
        }

        &:hover {
          color: ${(props) => props.theme.color.primaryColors.darkPurple};
          transition: ${(props) => props.theme.transition};

          svg {
            path {
              stroke: ${(props) => props.theme.color.primaryColors.darkPurple};
              transition: ${(props) => props.theme.transition};
            }
          }
        }

        &:focus,
        &:focus-visible {
          color: ${(props) => props.theme.color.primaryColors.darkPurple};
          text-decoration: underline;

          svg {
            path {
              stroke: ${(props) => props.theme.color.primaryColors.darkPurple};
            }
          }
        }
        &:disabled,
        &.disabled {
          opacity: 0.4;
          pointer-events: none;
        }
      }
    }
  }

  .contactsRightBlock {
    gap: 24px;
    .blockTitle {
      height: auto;

      h3 {
        font-weight: bold;
      }
    }
    .contactTextBlock {
      height: auto;

      p {
        text-transform: none !important;
        color: ${(props) => props.theme.color.primaryColors.secFontColor};
      }
    }

    .locationBlock {
      gap: 24px;

      .location {
        gap: 24px;

        a {
          &:hover {
            color: ${(props) => props.theme.color.primaryColors.darkPurple};
          }
        }
      }
    }

    .socialMediaWrapper {
      gap: 24px;
      margin-top: 16px;

      .socialMediaLinks {
        gap: 16px;

        .button {
          svg {
            display: none;
          }

          button {
            font-weight: 600;
          }
        }
      }

      h5 {
        font-weight: 600;
        text-transform: none;
      }
    }
  }

  /*captcha*/

  .captchaWrapper {
    height: auto;
    justify-content: flex-start;
    border-radius: 10px;
    padding: 0;
    position: relative;

    .rc-anchor-light.rc-anchor-normal,
    .rc-anchor-light.rc-anchor-compact {
      order: none !important;
      background: rgba(33, 37, 41, 0.08) !important;
    }

    iframe {
      width: 100% !important;

      .rc-anchor-light {
        border: none !important;
        background: transparent !important;
      }
    }

    .captchaCheck {
      height: auto;

      p {
        color: ${(props) => props.theme.color.primaryColors.secFontColor};
      }
    }
    .captchaImage {
      height: auto;
      width: auto;
      svg {
        height: 44px;
        width: auto;
      }
    }
  }

  .privacyPolicy {
    padding: 0 15px;
  }

  /*radio*/
  .radioContainer {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    height: 16px;
    width: 16px;
    cursor: pointer;
    font-size: 16px;
    user-select: none;

    .radioMark {
      position: absolute;
      top: 0;
      left: 0;
      height: 16px;
      width: 16px;
      padding: 3px;
      background-color: #fff;
      border-radius: 16px;
      transition: background-color 0.4s ease-in-out;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #adb5bd;

      &::after {
        content: "";
        height: 100%;
        width: 100%;
        display: none;
        background-color: #556aeb;
      }
    }

    .customRadio {
      position: absolute;
      opacity: 0;
      margin: 0;
      padding: 0;
      cursor: pointer;
      height: 100%;
      z-index: 5;
      width: 100%;

      &:checked ~ .radioMark {
        background-color: #556aeb;
        border: 1px solid #556aeb;

        &::after {
          content: "";
          height: 8px;
          max-height: 8px;
          max-width: 8px;
          background-color: #fff;
          display: flex;
          border-radius: 100%;
          animation: checkAnim 0.4s ease-in-out forwards;
        }
      }
    }
    @keyframes checkAnim {
      0% {
        height: 0;
        width: 0;
      }

      100% {
        height: 10px;
        width: 10px;
      }
    }
  }

  @media only screen and (max-width: 1450px) {
    padding: 124px 100px;
  }

  @media only screen and (max-width: 1024px) {
    padding: 124px 80px;
    gap: 32px;
  }

  /* MOBILE*/
  @media only screen and (max-width: 815px) {
    padding: 84px 40px;
  }

  /* MOBILE MEDIUM*/
  @media only screen and (max-width: 650px) {
    flex-direction: column;
    .formDouble {
      &.contactTypeForm {
        align-items: flex-start;

        .radioForm {
          align-items: flex-start;
        }
      }
    }
  }

  /* MOBILE SMALL*/
  @media only screen and (max-width: 390px) {
  }

  .messageStatusWrapper {
    position: sticky;
    bottom: 20px;
    left: 20px;
    gap: 16px;

    .toaster {
      border-radius: 5px;
      padding: 10px 20px;
      height: auto;
      gap: 16px;

      p {
        color: ${(props) => props.theme.color.primaryColors.white};
        line-height: normal;
      }

      &.sent {
        background-color: ${(props) => props.theme.color.primaryColors.labelPurple};

        svg {
          height: 18px;
          cursor: pointer;
          width: auto;
          path {
            stroke: ${(props) => props.theme.color.primaryColors.white};
          }
          circle {
            fill: ${(props) => props.theme.color.primaryColors.white};
            stroke: ${(props) => props.theme.color.primaryColors.white};
          }
        }
      }
      &.error {
        background-color: ${(props) => props.theme.color.primaryColors.yellow};
        svg {
          height: 18px;
          cursor: pointer;
          width: auto;
          path {
            stroke: ${(props) => props.theme.color.primaryColors.white};
          }
          circle {
            fill: ${(props) => props.theme.color.primaryColors.white};
            stroke: ${(props) => props.theme.color.primaryColors.white};
          }
        }
      }
      &.neutral {
        background-color: ${(props) => props.theme.color.primaryColors.secFontColor};

        svg {
          height: 18px;
          cursor: pointer;
          width: auto;
          path {
            stroke: ${(props) => props.theme.color.primaryColors.white};
          }
          circle {
            stroke: ${(props) => props.theme.color.primaryColors.white};
          }
        }
      }
    }
  }
`;

export class ContactBlock extends BaseComponent {
  constructor(props) {
    super(props);
    this.recaptchaRef = React.createRef();
    this.state = this.getDefaultState();
  }

  getDefaultState = () => {
    return {
      isCandidate: true,
      name: "",
      email: "",
      message: "",
      privacyPolicy: false,
      showSuccessMessage: false,
      successMessage: "",
      showErrorMessage: false,
      errorMessage: "",
      showNeutralMessage: false,
      neutralMessage: "",
      recaptchaValidated: false,
    };
  };

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  isSendDisabled = () => {
    return this.state.privacyPolicy == false || this.state.name?.trim() == "" || this.state.email?.trim() == "" || validateEmailFormat(this.state.email?.trim()) == false || this.state.message?.trim() == "" || this.state.recaptchaValidated == false;
  };

  sendContactUsEmail = () => {
    this.setGlobalLoading(true);
    fetch("api/Home/ContactUsEmail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        isCandidate: this.state.isCandidate,
        name: this.state.name,
        email: this.state.email,
        message: this.state.message,
        lang: new BaseComponent().getLanguageText(),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data == true) {
          this.setState({ ...this.getDefaultState(), showSuccessMessage: true, successMessage: this.translation.contactForm.successMessage });
        } else {
          this.setState({ ...this.getDefaultState(), showErrorMessage: true, errorMessage: this.translation.contactForm.errorMessage });
        }
        this.setGlobalLoading(false);
      });
  };

  verifyRecaptcha = async () => {
    const captchaValue = this.recaptchaRef.current.getValue();

    if (!captchaValue) {
      this.setState({ recaptchaValidated: false });
      return;
    }

    try {
      fetch("api/Captcha/VerifyCaptcha", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ captchaValue }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            this.setState({ recaptchaValidated: true });
          } else {
            this.setState({ recaptchaValidated: false });
          }
        });
    } catch (error) {
      console.error("Error during reCAPTCHA verification:", error);
      this.setState({ recaptchaValidated: false });
    }
  };

  render() {
    return (
      <StyledContactBlock className="contactBlock" id="contacts" alignItems="flex-start">
        <NanoFlex className="contactsLeftBlock" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
          <NanoFlex className="blockTitle" justifyContent="flex-start">
            <Type.h3>
              <b>{this.translation.global.contactUs}</b>
            </Type.h3>
          </NanoFlex>
          <NanoFlex className="contactTextBlock" justifyContent="flex-start">
            <Type.p>{this.translation.contactForm.contactFormSubtitle}</Type.p>
          </NanoFlex>

          <NanoFlex className="contactFormWrapper" flexDirection="column">
            <NanoFlex className="formDouble contactTypeForm">
              <NanoFlex className="radioForm" justifyContent="flex-start">
                <NanoFlex className="radioContainer">
                  <input class="customRadio" type="radio" name="messageType" onChange={() => this.setState({ isCandidate: false })} />
                  <NanoFlex className="radioMark"> </NanoFlex>
                </NanoFlex>

                <Type.p className="bold">{this.translation.contactForm.imClient}</Type.p>
              </NanoFlex>
              <NanoFlex className="radioForm" justifyContent="flex-start">
                <NanoFlex className="radioContainer">
                  <input class="customRadio" type="radio" name="messageType" onChange={() => this.setState({ isCandidate: true })} defaultChecked />
                  <NanoFlex className="radioMark"> </NanoFlex>
                </NanoFlex>
                <Type.p className="bold">{this.translation.contactForm.imCandidade}</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="formDouble">
              <NanoFlex className="formWrapper">
                <Input defaultValue={this.state.email} onChangeAction={(val) => this.setState({ email: val })} title={this.translation.contactForm.email} placeholder={this.translation.contactForm.emailPlaceholder} />
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="formDouble">
              <NanoFlex className="formWrapper">
                <Textarea defaultValue={this.state.message} onChangeAction={(val) => this.setState({ message: val })} title={this.translation.contactForm.message} placeholder={this.translation.contactForm.mesagePlaceholder} />
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="formDouble" alignItems="flex-end">
              <NanoFlex className="formWrapper">
                <Input defaultValue={this.state.name} onChangeAction={(val) => this.setState({ name: val })} title={this.translation.contactForm.name} placeholder={this.translation.contactForm.namePlaceholder} />
              </NanoFlex>
              <SimpleButton darkPurple label={this.translation.global.send} disabled={this.isSendDisabled()} clickAction={this.sendContactUsEmail}></SimpleButton>
            </NanoFlex>
            <NanoFlex className="formDouble" alignItems="flex-end">
              <NanoFlex className="formWrapper privacyPolicy" justifyContent="flex-start">
                <NanoFlex className="checkbox">
                  <input type="checkbox" onChange={(e) => this.setState({ privacyPolicy: e.currentTarget.checked })} />
                  <NanoFlex className="checkmark">
                    <CheckIcon />
                  </NanoFlex>
                </NanoFlex>
                <Type.p>
                  {this.translation.contactForm.readAndAccepted} <Link to="/privacy-policy">{this.translation.contactForm.privacyPolicy}</Link>
                </Type.p>
              </NanoFlex>
            </NanoFlex>

            <NanoFlex className="captchaWrapper">
              <ReCAPTCHA onChange={() => this.verifyRecaptcha()} ref={this.recaptchaRef} sitekey={window.env.REACT_APP_SITE_KEY} />
            </NanoFlex>
          </NanoFlex>
          {/* FORM MESSAGES STATUS */}
          <NanoFlex className="messageStatusWrapper " flexDirection="column" alignItems="flex-end">
            <NanoFlex className={`toaster neutral ${!this.state.showNeutralMessage ? "hide" : ""}`} justifyContent="flex-start">
              <InfoIcon />
              <NanoFlex justifyContent="flex-start">
                <Type.p>{this.state.neutralMessage}</Type.p>
              </NanoFlex>
              <CloseIcon onClick={() => this.setState({ showNeutralMessage: false, neutralMessage: "" })} />
            </NanoFlex>
            <NanoFlex className={`toaster sent ${!this.state.showSuccessMessage ? "hide" : ""}`} justifyContent="flex-start">
              <CheckIcon />
              <NanoFlex justifyContent="flex-start">
                <Type.p>{this.state.successMessage}</Type.p>
              </NanoFlex>
              <CloseIcon onClick={() => this.setState({ showSuccessMessage: false, successMessage: "" })} />
            </NanoFlex>
            <NanoFlex className={`toaster error ${!this.state.showErrorMessage ? "hide" : ""}`} justifyContent="flex-start">
              <WarningIcon />
              <NanoFlex justifyContent="flex-start">
                <Type.p>{this.state.errorMessage}</Type.p>
              </NanoFlex>
              <CloseIcon onClick={() => this.setState({ showErrorMessage: false, errorMessage: "" })} />
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
        <NanoFlex className="contactsRightBlock" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
          <NanoFlex className="blockTitle" justifyContent="flex-start">
            <Type.h3>{this.translation.contactForm.contactDetails.contactUs}</Type.h3>
          </NanoFlex>
          <NanoFlex className="contactTextBlock" justifyContent="flex-start">
            <Type.p>{this.translation.contactForm.contactDetails.locationSubtitle}</Type.p>
          </NanoFlex>

          <NanoFlex className="locationBlock" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="location" justifyContent="flex-start" alignItems="flex-start">
              <Type.p>{this.translation.contactForm.contactDetails.adress}</Type.p>
            </NanoFlex>
            <NanoFlex className="location" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
              <a href="mailto:info@chaseup.pt">
                <Type.p>{this.translation.contactForm.contactDetails.email}</Type.p>
              </a>
              <a href="tel:+351229376700">
                <Type.p>{this.translation.contactForm.contactDetails.phoneNumber}</Type.p>
              </a>
            </NanoFlex>
          </NanoFlex>

          <NanoFlex className="socialMediaWrapper" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <Type.h5>{this.translation.contactForm.contactDetails.alsoHere}</Type.h5>

            <NanoFlex className="socialMediaLinks" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
              <a href="https://www.instagram.com/chaseup.rh/" rel="noopener noreferrer" target="_blank">
                <LinkButton label={this.translation.contactForm.contactDetails.instagram}></LinkButton>
              </a>
              <a href="https://linkedin.com/company/chaseup-rh" rel="noopener noreferrer" target="_blank">
                <LinkButton label={this.translation.contactForm.contactDetails.linkedin}></LinkButton>
              </a>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </StyledContactBlock>
    );
  }
}
